import React, { useEffect } from "react";
import { useState } from "react";
import moment from "moment";
import { Modal } from "react-bootstrap";
import { Container, Col, Row } from "reactstrap";
import {
  getFunds,
  deleteFund,
  updateFundStatus,
  searchFundAPI,
} from "../../../stores/services/funds.service";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import ViewFund from "./view-fund";
import EditFunds from "./edit-fund";

type PageInfo = {
  hasNextPage: boolean;
  hasPrevPage: boolean;
  limit: number;
  page: number;
  totalDocs: number;
  totalPages: number;
  pagingCounter: number;
  nextPage: number | null;
  next_page_number: number | null;
  prevPage: number | null;
};

const FundList = ({ parent_fund = "", fund_page = "true" }) => {
  const arrFundManagement = [
    {
      value: "main_fund",
      label: "Main Fund",
    },
    {
      value: "sub_fund",
      label: "Sub Fund",
    },
    {
      value: "plan",
      label: "Plan",
    },
  ];

  const history = useHistory();
  const UserDepartmentRole = JSON.parse(
    sessionStorage.getItem("loggedInUser") || "{}"
  )?.department_role;
  const [fund_code, setFund_code] = useState(
    JSON.parse(sessionStorage.getItem("fund_code") || "[]")
  );
  const email = sessionStorage.getItem("email") || "";
  const amcCode = sessionStorage.getItem("amc_code") || "";
  const [Loading, setLoading] = useState(false);
  const [data, setData] = useState<any>([]);
  let [activePage, setActivePage] = useState("1");
  const [pageInfo, setPageInfo] = useState<PageInfo>({
    hasNextPage: false,
    hasPrevPage: false,
    limit: 10,
    page: 1,
    totalDocs: 0,
    totalPages: 0,
    pagingCounter: 0,
    nextPage: null,
    next_page_number: null,
    prevPage: null,
  });
  const [pageSize, setPageSize] = useState("10");
  const [isSearchActive, setSearchActive] = useState(false);
  const [modalList, setModalList] = useState(false);
  const [selectedItem, setSelectedItem] = useState<any>();
  const [hasNext, setHasNext] = useState(false);

  React.useEffect(() => {
    if (sessionStorage.getItem("fund_code")) {
      setFund_code(JSON.parse(sessionStorage.getItem("fund_code") || "[]"));
    } else {
      setFund_code(undefined);
    }
  }, []);

  React.useEffect(() => {
    const handleStorageChange = () => {
      const fundCode = sessionStorage.getItem("fund_code");
      setFund_code(fundCode ? JSON.parse(fundCode) : undefined);
    };

    handleStorageChange();

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  const getFundList = async (resetData: string = "") => {
    setLoading(true);
    try {
      const response = await getFunds({
        email,
        page_number: activePage,
        page_size: pageSize,
        fund_page,
        fund_code: fund_code?.length > 0 ? fund_code : "",
        parent_fund,
      });
      if (response.data.data.length > 0) {
        setPageInfo(response.data.page_info);
        setHasNext(response.data.page_info.hasNextPage);
        // setData(response.data.data);
        setData(
          resetData == "true"
            ? [...response.data.data]
            : [...data, ...response.data.data]
        );
      } else {
        setData([]);
        setHasNext(false);
        toast.error(response.data.message);
      }
    } catch (err: any) {
      setHasNext(false);
      // toast.error(error.response.data.message[0]);
      if (err.response !== undefined) {
        toast.error(err.response.data.message);
      } else {
        toast.error("Request Failed!");
      }
    }
    setLoading(false);
  };

  React.useEffect(() => {
    getFundList("true");
  }, [fund_code]);

  React.useEffect(() => {
    sessionStorage.removeItem("fundobj");

    activePage ? getFundList("") : getFundList("true");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activePage]);
  const [deletePopup, setDeletePopup] = useState(false);
  const [fundLoading, setFundLoading] = useState(false);
  const [statusSetPopup, setStatusSetPopup] = useState(false);
  const [currentAmcStatus, setCurrentAmcStatus] = useState("");
  const [modalFlag, setModalFlag] = useState("");
  const [code, setCode] = useState("");
  const updateStatus = async () => {
    setFundLoading(true);
    let status = "";
    if (currentAmcStatus === "active") {
      status = "deactive";
    } else {
      status = "active";
    }
    try {
      const response = await updateFundStatus(
        email,
        code,
        status,
        sessionStorage.getItem("amc_code") || ""
      );
      toast.success(response.data.message);
      setStatusSetPopup(false);
      getUpdatedFundList();
    } catch (error) {}
    setFundLoading(false);
  };

  const deleteFundSelected = async () => {
    setFundLoading(true);
    try {
      const response = await deleteFund(email, code);
      toast.success(response.data.message);
      setDeletePopup(false);
      getUpdatedFundList();
    } catch (error) {}
    setFundLoading(false);
  };

  const getUpdatedFundList = async () => {
    setLoading(true);
    try {
      const response = await getFunds({
        email,
        page_number: activePage,
        page_size: pageSize,
        fund_code: fund_code?.length > 0 ? fund_code : "",
        fund_page,
        parent_fund,
      });
      if (response.data.data.length > 0) {
        setPageInfo(response.data.page_info);
        setHasNext(response.data.page_info.hasNextPage);
        setData(response.data.data);
      } else {
        setData([]);
        setHasNext(false);
        toast.error(response.data.message);
      }
    } catch (error: any) {
      setHasNext(false);
      if (error.response !== undefined) {
        toast.error(error.response.data.message[0]);
      }
    }
    setLoading(false);
  };

  React.useEffect(() => {
    if (data) {
      let i;
      res.length = 0;
      setRes(res);
      for (i = 0; i < data.length; i++) {
        res.push(data[i]);
        setRes(res);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const [res, setRes] = useState<any>([]);
  const [searchValue, setSearchValue] = useState("");
  function myFunction(e: any) {
    res.length = 0;
    setRes(res);
    var filter, td, i;
    filter = e.target.value;
    for (i = 0; i < data.length; i++) {
      td = data[i].fund_name;
      if (td) {
        if (td.toUpperCase().indexOf(filter.toUpperCase()) > -1) {
          res.push(data[i]);
          setRes(res);
        } else {
        }
      }
    }
  }

  const searchFundData = async () => {
    setLoading(true);
    try {
      const response = await searchFundAPI(
        email,
        searchValue,
        fund_code?.length > 0 ? fund_code : "",
        amcCode,
        fund_page,
        parent_fund
      );
      // setData(response.data.data);
      // setSearchActive(true);
      // setPageSize('100');
      if (response.data.data.length > 0) {
        setPageInfo(response.data.page_info);
        setHasNext(response.data.page_info.hasNextPage);
        setData(response.data.data);
      } else {
        setHasNext(false);
        setData([]);
        toast.error(response.data.message?.toString());
      }
    } catch (error: any) {
      setHasNext(false);
      if (error.response !== undefined) {
        toast.error(error.response.data.message?.toString());
      }
    }
    setLoading(false);
  };

  const handleSearchValue = (e: any) => {
    setSearchValue(e.target.value);
    if (e.target.value.length === 0) {
      getUpdatedFundList();
      // setPageSize('10');
      setSearchActive(false);
      setSearchValue(e.target.value);
    } else {
      setSearchValue(e.target.value);
    }
  };

  const renderData = (category: any = "") => {
    return res.map((items: any, index: any) => {
      return (
        <tr key={index}>
          <td>
            <div className="d-flex align-items-center">
              {items.fund_name}
              {items?.fund_type && parent_fund && (
                <div
                  key={index}
                  style={{
                    borderRadius: "12px",
                    padding: "1px 7px",
                    border: "1px solid",
                  }}
                  className={`ml-1 d-flex`}
                >
                  <span className="sub-content">
                    {arrFundManagement?.find(
                      (ele) => ele?.value === items?.fund_type
                    )?.label || "-"}
                  </span>
                </div>
              )}
            </div>
          </td>
          <td>{items.symbol_code.replace("FUND_", "")}</td>
          {/* <td>{arrFundManagement?.find((ele) => ele?.value === items?.fund_type)?.label || "-"}</td> */}
          <td>{moment(items.created_at).format("DD-MM-YYYY")}</td>
          <td>{items.nav && parseFloat(items.nav).toFixed(4)}</td>
          <td>{items.nature}</td>
          <td>{items.status}</td>
          <td
            className="d-flex pointer"
            // onClick={() => {
            //   setStatusSetPopup(true);
            //   setCurrentAmcStatus(items.status);
            //   setCode(items.symbol_code.replace("FUND_", ""));
            // }}
          >
            <div
              // className="d-flex pointer"
              onClick={() => {
                setStatusSetPopup(true);
                setCurrentAmcStatus(items.status);
                setCode(items.symbol_code.replace("FUND_", ""));
              }}
            >
              {UserDepartmentRole != "Officer" && items.status !== "active" ? (
                <button
                  type="button"
                  className="btn-icon btn-link like btn btn-danger btn-sm"
                >
                  <i className="tim-icons icon-simple-remove"></i>
                </button>
              ) : (
                UserDepartmentRole != "Officer" && (
                  <button
                    type="button"
                    className="btn-icon btn-link like btn btn-success btn-sm"
                  >
                    <i className="fa fa-check"></i>
                  </button>
                )
              )}
            </div>
            <button
              type="button"
              className="btn-icon btn-link like btn btn-primary btn-sm"
              onClick={() => {
                sessionStorage.setItem("fundObj", JSON.stringify(items));
                if (parent_fund) {
                  setModalFlag("View");
                } else {
                  history.replace("/admin/view-fund");
                }
              }}
            >
              <i className="fa fa-eye"></i>
            </button>

            {UserDepartmentRole != "Officer" && (
              <button
                type="button"
                className="btn-icon btn-link like btn btn-info btn-sm"
                onClick={() => {
                  sessionStorage.setItem("fundobj", JSON.stringify(items));
                  if (parent_fund) {
                    setModalFlag("Edit");
                  } else {
                    history.replace(`/admin/edit-fund`);
                  }
                }}
              >
                <i className="tim-icons icon-pencil"></i>
              </button>
            )}

            {items?.child_fund?.length > 0 && (
              <button
                type="button"
                className="btn-icon btn-link like btn btn-primary btn-sm"
                onClick={() => {
                  setModalList(true);
                  setSelectedItem(items);
                }}
              >
                <i className="fa fa-list"></i>
              </button>
            )}
          </td>
        </tr>
      );
    });
  };
  const renderComponents = () => {
    switch (statusSetPopup) {
      case true:
        return (
          <Modal className="" dialogClassName="modal60w" show={true}>
            <div className="modal-header justify-content-center">
              <button
                aria-hidden="true"
                className="close"
                onClick={() => {
                  setStatusSetPopup(false);
                }}
                data-dismiss="modal"
                type="button"
              >
                <i className="tim-icons icon-simple-remove"></i>
              </button>
              <h6 className="title title-up">Action</h6>
            </div>
            <div className="modal-body">
              <div className="text-center">
                <Row>
                  <div className="mx-auto">
                    {currentAmcStatus === "active" ? (
                      <img src="assets/ban.svg" alt="" width="70" />
                    ) : (
                      <img src="assets/check.svg" alt="" width="70" />
                    )}
                    <h1 className="pb-3">Are You Sure?</h1>
                    Are you sure you want to{" "}
                    {currentAmcStatus === "active"
                      ? "Deactivate"
                      : "Activate"}{" "}
                    this Fund?
                  </div>
                </Row>
                <Row className="mt-4">
                  <Col>
                    <div className="">
                      <button
                        className="btn btn-primary"
                        disabled={Boolean(fundLoading)}
                        onClick={() => {
                          updateStatus();
                        }}
                      >
                        {fundLoading ? (
                          <>
                            <span
                              className="spinner-border login-txt spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            <span className="login-txt"> Loading...</span>
                          </>
                        ) : (
                          "Yes"
                        )}
                      </button>
                    </div>
                  </Col>
                  <Col>
                    <div className="">
                      <button
                        className="btn btn-default"
                        onClick={() => {
                          setStatusSetPopup(false);
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </Modal>
        );
      default:
        return "";
    }
  };
  const renderDeletePopup = () => {
    switch (deletePopup) {
      case true:
        return (
          <Modal className="" dialogClassName="modal60w" show={true}>
            <div className="modal-body">
              <div className="text-center">
                <Row>
                  <div className="mx-auto">
                    <img src="assets/ban.svg" alt="" width="70" />
                    <h1 className="pb-3">Are You Sure?</h1>
                    Are You sure, you want to delete selected Fund?
                  </div>
                </Row>
                <Row>
                  <Col>
                    <div className="">
                      <button
                        className="btn btn-primary"
                        disabled={Boolean(fundLoading)}
                        onClick={() => {
                          deleteFundSelected();
                        }}
                      >
                        {fundLoading ? (
                          <>
                            <span
                              className="spinner-border login-txt spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            <span className="login-txt"> Loading...</span>
                          </>
                        ) : (
                          "Yes"
                        )}
                      </button>
                    </div>
                  </Col>
                  <Col>
                    <div className="">
                      <button
                        className="btn btn-default"
                        onClick={() => {
                          setDeletePopup(false);
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </Modal>
        );
      default:
        return "";
    }
  };
  return (
    <>
      <div className="content">
        <Row>
          <Modal
            className="mx-2 w-full"
            dialogClassName="modal100w"
            show={modalList}
            onHide={() => {
              setModalList(false);
              setSelectedItem([]);
            }}
          >
            <div className="modal-header justify-content-between align-items-center">
              <button
                aria-hidden="true"
                className="close"
                onClick={() => {
                  setModalList(false);
                  setSelectedItem([]);
                }}
                data-dismiss="modal"
                type="button"
              >
                <i className="tim-icons icon-simple-remove"></i>
              </button>
              <h6 className="title title-up">List of Child Funds</h6>
            </div>
            <div className="modal-body">
              <FundList fund_page={"child"} parent_fund={selectedItem?._id} />
            </div>
          </Modal>

          {/* ------------------- Edit/View Modal ------------------------ */}
          <Modal
            className="mx-2 w-full"
            dialogClassName="modal100w"
            show={modalFlag}
            onHide={() => {
              setModalFlag("");
              setSelectedItem([]);
            }}
          >
            <div className="modal-header justify-content-between align-items-center">
              <button
                aria-hidden="true"
                className="close"
                onClick={() => {
                  setModalFlag("");
                  setSelectedItem([]);
                }}
                data-dismiss="modal"
                type="button"
              >
                <i className="tim-icons icon-simple-remove"></i>
              </button>
              <h6 className="title title-up">{modalFlag} Fund</h6>
            </div>
            <div className="modal-body">
              {modalFlag === "Edit" ? (
                <EditFunds setModalFlag={setModalFlag} child={"true"} />
              ) : modalFlag === "View" ? (
                <ViewFund child={"true"} />
              ) : (
                ""
              )}
            </div>
          </Modal>

          <Col md="12">
            <Container fluid>
              <ToastContainer limit={1} />
              <div className="card">
                <div className="d-flex align-items-center"></div>
                {!Loading ? (
                  <div className="">
                    <div className="card-header">
                      <div className="card-title">
                        <h4>
                          Fund Listing
                          {parent_fund === "" && (
                            <>
                              <button
                                className="btn btn-primary btn-sm float-right"
                                onClick={() => {
                                  history.replace("/admin/add-fund");
                                }}
                              >
                                <i className="fa fa-plus mr-2"></i> Add New
                              </button>
                            </>
                          )}
                        </h4>
                      </div>
                    </div>
                    <div className="card-body">
                      {/* <div className="input-holder">	 */}
                      <Row>
                        <Col md="4">
                          <div className="form-group">
                            <ReactTooltip
                              textColor="white"
                              backgroundColor="black"
                              effect="float"
                            />
                            <input
                              type="search"
                              id="myInput"
                              data-tip="Fund Name"
                              placeholder="Enter Fund Name"
                              className="form-control"
                              value={searchValue}
                              onChange={(e) => {
                                // setSearchValue(e.target.value);
                                // myFunction(e);
                                handleSearchValue(e);
                              }}
                              // onKeyPress={(e)=>{
                              //   let key_board_keycode = e.which || e.keyCode;
                              //   if (key_board_keycode == 13) {
                              //     e.preventDefault();
                              //     searchFundData();
                              //   }
                              // }}
                            />
                          </div>
                        </Col>
                        <Col md="4">
                          <button
                            style={{
                              marginTop: "1px",
                            }}
                            className="btn btn-primary"
                            onClick={searchFundData}
                          >
                            <i className="fa fa-search"></i> Search
                          </button>
                        </Col>
                      </Row>

                      {/* </div>	 */}

                      <div className="table-responsive">
                        <table className="table">
                          <thead>
                            <th
                              style={{
                                paddingLeft: "7px",
                                paddingRight: "7px",
                              }}
                            >
                              Fund Name
                            </th>
                            <th
                              style={{
                                paddingLeft: "7px",
                                paddingRight: "7px",
                              }}
                            >
                              Fund Code
                            </th>
                            {/* <th
                              style={{
                                paddingLeft: "7px",
                                paddingRight: "7px",
                              }}
                            >
                              Fund Type
                            </th> */}
                            {/* <th>AMC Code</th> */}
                            {/* <th>Amount</th> */}
                            <th
                              style={{
                                paddingLeft: "7px",
                                paddingRight: "7px",
                              }}
                            >
                              Created At
                            </th>
                            <th
                              style={{
                                paddingLeft: "7px",
                                paddingRight: "7px",
                              }}
                            >
                              NAV
                            </th>
                            <th
                              style={{
                                paddingLeft: "7px",
                                paddingRight: "7px",
                              }}
                            >
                              Nature
                            </th>
                            <th
                              style={{
                                paddingLeft: "7px",
                                paddingRight: "7px",
                              }}
                            >
                              Status
                            </th>
                            <th
                              style={{
                                paddingLeft: "11px",
                                paddingRight: "11px",
                              }}
                            >
                              Action
                            </th>
                          </thead>
                          <tbody>{renderData()}</tbody>
                        </table>
                        {!isSearchActive && parent_fund === "" && hasNext && (
                          <div className="row justify-content-center pointer">
                            <button
                              aria-hidden={true}
                              className="btn btn-primary btn-sm mt-2 py-2 px-3"
                              disabled={!pageInfo.hasNextPage || Loading}
                              type="button"
                              onClick={() => {
                                setActivePage(String(pageInfo.nextPage));
                              }}
                            >
                              {Loading ? (
                                <span>
                                  Loading...{" "}
                                  <i
                                    className="fa fa-spinner fa-spin  "
                                    aria-hidden="true"
                                  ></i>
                                </span>
                              ) : (
                                "Show More"
                              )}
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="d-flex justify-content-center my-5">
                    <i
                      className="fa fa-spinner fa-spin fa-3x"
                      aria-hidden="true"
                    ></i>
                  </div>
                )}
                {renderDeletePopup()}
                {renderComponents()}
              </div>
            </Container>
          </Col>
        </Row>
      </div>
    </>
  );
};
export default FundList;
